import {
    AutocompleteInput,
    Create,
    DateInput,
    NumberInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, Building2, TrendingUp } from "lucide-react";
import { required } from "ra-core";
import { useWatch } from "react-hook-form";
import { AutoReferenceField } from "../documents/shared/AutoReferenceField";
import { FilteredContactInput } from "../misc/FilteredContactInput";

const LostReasonInput = () => {
    const stage = useWatch({ name: 'stage' });
    if (stage !== 'lost') return null;

    return (
        <TextInput
            source="lost_reason"
            label="Reason for Loss"
            multiline
            rows={2}
            className="w-full mt-4"
        />
    );
};

export const OpportunityCreate = () => (
    <Create title="Create Opportunity">
        <SimpleForm className="max-w-4xl mx-auto space-y-6">
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <Briefcase className="w-5 h-5 text-primary" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Opportunity Info</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <AutoReferenceField docType="opportunity" />
                        <SelectInput 
                            source="stage" 
                            label="Pipeline Stage"
                            defaultValue="inquiry"
                            choices={[
                                { id: 'inquiry', name: 'Inquiry' },
                                { id: 'requirement_discussion', name: 'Requirement Discussion' },
                                { id: 'proposal', name: 'Proposal' },
                                { id: 'won', name: 'Won' },
                                { id: 'lost', name: 'Lost' },
                            ]}
                            className="w-full"
                        />
                    </div>
                    <LostReasonInput />
                </CardContent>
            </Card>

            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <Building2 className="w-5 h-5 text-muted-foreground" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Customer & Enquiry</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <ReferenceInput source="company_id" reference="companies">
                            <AutocompleteInput label="Company" validate={required()} className="w-full" />
                        </ReferenceInput>
                        <FilteredContactInput label="Contact Person" className="w-full" />
                        <ReferenceInput source="enquiry_id" reference="enquiries">
                            <AutocompleteInput label="Linked Enquiry" optionText="reference" className="w-full" />
                        </ReferenceInput>
                    </div>
                </CardContent>
            </Card>

            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <TrendingUp className="w-5 h-5 text-emerald-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Valuation</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <NumberInput source="deal_value" label="Expected Deal Value (₹)" className="w-full" />
                        <NumberInput source="win_probability" label="Win Probability (%)" min={0} max={100} defaultValue={10} className="w-full" />
                        <DateInput source="expected_close_date" label="Expected Close Date" className="w-full" />
                    </div>
                </CardContent>
            </Card>
        </SimpleForm>
    </Create>
);
